import { Typography } from "@suraasa/placebo-ui"
import { AISparkleFilled } from "assets/icons/system/AISparkle"
import { AI_TOOLS_ONBOARDING_TARGETS } from "features/Home/SuraasaPlusNewYearOnboarding/AIToolsOnboarding/types"
import { ArrowRightCircleSolid } from "iconoir-react"
import { Link } from "react-router-dom"

const Card = ({
  title,
  to,
  gradient,
  description,
  className,
}: {
  title: string
  to: string
  gradient: string
  description: string
  className: string
}) => {
  return (
    <Link
      to={to}
      className={`group min-w-[240px] rounded-[16px] border-2 border-solid border-[#EBE9E6] bg-[#F7F6F5]  hover:border-[#D6D3D1] ${className}`}
      data-tour={AI_TOOLS_ONBOARDING_TARGETS.takeALook}
    >
      <div className="flex h-[256px] flex-col items-end justify-between rounded-2xl p-2.5">
        <div>
          <div
            className="mb-1 flex size-5 items-center justify-center rounded-[12px] shadow-[1px_1px_5px_0px_rgba(0,0,0,0.1)]"
            style={{ background: gradient }}
          >
            <AISparkleFilled fill="#ffffff" widths={"24px"} height={"20px"} />
          </div>

          <Typography variant="title3">{title}</Typography>
          <Typography
            variant={"smallBody"}
            className="mt-0.5 text-onSurface-500"
          >
            {description}
          </Typography>
        </div>
        <ArrowRightCircleSolid className="size-[26px] text-[#57534D] opacity-0 group-hover:opacity-100" />
      </div>
    </Link>
  )
}

export default Card
